import { render, staticRenderFns } from "./DivisionList.vue?vue&type=template&id=42e3e894"
import script from "./DivisionList.js?vue&type=script&lang=js&external"
export * from "./DivisionList.js?vue&type=script&lang=js&external"
import style0 from "./DivisionList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports